import actionLabels from './actionLabels';
import errorMessages from './errorMessages';
import helpMessages from './helpMessages';

const text = { actionLabels, errorMessages, helpMessages };

export default text;
